
import { showLoading, hideLoading } from "../../../loading";
import request from "../../../request";
import swal from 'sweetalert';
import ResponsiveTable from "../../../components/ResponsiveTable";
import VerifiedIcon from '@mui/icons-material/Verified';
import Gender from "../../../components/Gender";
import { connect } from "react-redux";
import RoundedIconButton from "../../../components/RoundedIconButton";
import DeleteIcon from '@mui/icons-material/Delete';
import Editor from "./Editor";
import { requestConfirmation } from "../../../utils";
import { Chip, IconButton, Menu, MenuItem } from "@mui/material";
import AddIcon from '@mui/icons-material/Add';
import { USER_ROLE } from "../../../../../shared/constants";
import { successToast } from "../../../toast";
import Email from "../../../components/Email";
import NavigationStateSaver from "../../../components/NavigationStateSaver";
import Image from "../../../components/Image";
import AccountCircle from '@mui/icons-material/AccountCircle';


class _Users extends NavigationStateSaver {

   state = {
      users: null,
      page: 0,
      pageSize: 10,
      usersCount: 0,
      editorOpen: false,
      addRoleAnchorEl: null,
      selectedUser: null,
   }

   fetchUsers = async () => {
      try {

         showLoading();

         const params = {
            page: this.state.page + 1,
            limit: this.state.pageSize,
         }

         const res = await request.get('/api/admin/users', { params });
         const { users, total } = res.data;

         this.setState({ users, usersCount: total });

      } catch (err) {
         swal("Error", err.toString(), "error");
      } finally {
         hideLoading();
      }
   }

   deleteUser = async (user) => {

      // confirm
      const confirmed = await requestConfirmation(`Delete ${user.name} ${user.surname}?`);
      if (!confirmed)
         return;

      // delete
      try {

         showLoading();

         await request.delete(`/api/admin/users/${user._id}`);
         const users = this.state.users.filter(u => u._id !== user._id);

         this.setState({ users });

      } catch (err) {
         swal("Error", err.toString(), "error");
      } finally {
         hideLoading();
      }
   }

   deleteUserRole = async (user, role) => {

      // confirm
      const confirmed = await requestConfirmation(`Remove "${role}" role from ${user.name} ${user.surname}?`);
      if (!confirmed)
         return;

      // check if last role
      if (user.roles.length === 1) {
         swal("Error", "User must have at least one role", "error");
         return;
      }

      // delete
      try {

         showLoading();

         const res = await request.patch(`/api/admin/users/${user._id}`, {
            roles: user.roles.filter(r => r !== role)
         });

         const users = this.state.users.map(u => {
            if (u._id === user._id)
               return res.data;
            return u;
         });

         this.setState({ users });


      } catch (err) {
         swal("Error", err.toString(), "error");
      } finally {
         hideLoading();
      }
   }

   addUserRole = async (user, role) => {

      const roles = [...user.roles, role ];

      try {
            
         showLoading();

         const res = await request.patch(`/api/admin/users/${user._id}`, { roles });

         const users = this.state.users.map(u => {
            if (u._id === user._id)
               return res.data;
            return u;
         });

         this.setState({ users });
         successToast(`"${role}" role added to ${user.name} ${user.surname}`);

      } catch (err) {
         swal("Error", err.toString(), "error");
      } finally {
         hideLoading();
      }
   }

   getAllowedRoles = () => {
      let roles = Object.values(USER_ROLE);
      if (!this.props.user.roles.includes(USER_ROLE.SUPER_ADMIN))
         roles = roles.filter(role => role !== USER_ROLE.SUPER_ADMIN);
      return roles;
   }

   async componentDidMount() {
      await super.componentDidMount();
      if (!this.state.users)
         this.fetchUsers();
   }

   render() {

      const { user } = this.props;
   
      return <>
         <ResponsiveTable
            cols={[
               {
                  field: 'profile_picture',
                  caption: '',
                  render: profilePicture => {
                     if (profilePicture)
                        return <div className="w-[40px] aspect-square overflow-hidden rounded-full border-[1px]">
                           <Image
                              src={profilePicture}
                              alt="Profile"
                              className="w-10 h-10 rounded-full"
                           />
                        </div>

                     return <AccountCircle
                        className="text-[40px] text-gray-400"
                     />
                  }
               },
               {
                  field: 'name',
                  caption: 'Name',
                  render: (name, user) => <span>{name} {user.surname}</span>
               },
               {
                  field: 'gender',
                  caption: 'Gender',
                  render: gender => <Gender gender={gender} />
               },
               {
                  field: 'email',
                  caption: 'Email',
                  render: email => <Email email={email} />
               },
               {
                  field: 'roles',
                  caption: 'Roles',
                  render: (roles, _user) => {
                     const rolesJSX = roles.map(role => <Chip
                        key={role}
                        label={role.replace(/[_-]/g, ' ').toUpperCase()}
                        size="small"
                        className="mr-1"
                        variant="outlined"
                        onDelete={() => this.deleteUserRole(_user, role)}
                     />)

                     return <>
                        <IconButton
                           size="small"
                           color="primary"
                           onClick={e => {
                              this.setState({
                                 addRoleAnchorEl: e.currentTarget,
                                 selectedUser: _user
                              });
                           }}
                        >
                           <AddIcon />
                        </IconButton>
                        {rolesJSX}
                     </>
                  }
               },
               {
                  field: 'verified',
                  caption: 'Verified',
                  render: (verified) => verified && <VerifiedIcon className="text-green-600" />
               },
               {
                  field: 'actions',
                  caption: '',
                  render: (_, item) => {

                     return <>
                        <RoundedIconButton
                           size="small"
                           color="danger"
                           className="ml-1"
                           onClick={() => this.deleteUser(item)}
                           disabled={item._id === user._id}
                        >
                           <DeleteIcon fontSize="small" />
                        </RoundedIconButton>
                     </>
                  }
               }
            ]}
            rows={this.state.users}
            fullHeight
            onRefresh={this.fetchUsers}
            onAdd={() => this.setState({ editorOpen: true })}
            pagination={{
               page: this.state.page,
               count: this.state.usersCount,
               rowsPerPage: this.state.pageSize,
               labelRowsPerPage: "Users per page",
               onPageChange: async (e, page) => {
                  await this.updateState({ page });
                  this.fetchUsers();
               },
               onRowsPerPageChange: async (e) => {
                  const pageSize = e.target.value;
                  await this.updateState({ pageSize, page: 0 });
                  this.fetchUsers();
               }
            }}
         />
         {
            this.state.editorOpen && <Editor
               onClose={
                  user => {
                     const update = { editorOpen: false };
                     if (user)
                        update.users = [user, ...this.state.users];

                     this.setState(update);
                  }
               }
               allowedRoles={this.getAllowedRoles()}
            />
         }
         { 
            this.state.addRoleAnchorEl && <Menu
               anchorEl={this.state.addRoleAnchorEl}
               open
               onClose={() => this.setState({ addRoleAnchorEl: null })}
            >
               {
                  this
                     .getAllowedRoles()
                     .filter(role => !this.state.selectedUser.roles.includes(role))
                     .map(role => <MenuItem
                        key={role}
                        onClick={async () => {
                           this.setState({ addRoleAnchorEl: null });
                           await this.addUserRole(this.state.selectedUser, role);
                        }}
                     >
                        {role.replace(/[_-]/g, ' ').toUpperCase()}
                     </MenuItem>)
               }
            </Menu>
         }
      </>
   }
}

const mapStateToProps = state => ({ user: state.user });
const Users = connect(mapStateToProps)(_Users);

export default Users;